import React from 'react';
import { NextPage } from 'next';
import AppWrapper from '../app_wrapper';
import PageNotFoundCommon from '../components/pages/PageNotFound';

const PageNotFound: NextPage = () => {
  return <AppWrapper desktopComp={<PageNotFoundCommon isDesktop />} mobileComp={<PageNotFoundCommon />} />;
};

PageNotFound.getInitialProps = ({ req }) => {
  if (req) {
    (req as any).datadog.increment('consumer_app.page_not_found');
  }
  return null;
};

export default PageNotFound;
